import classes from './OverviewSection.module.scss';
import React from 'react';

const OverviewSection = () => {
	return <div className={classes.dashboard}>Áttekintés</div>;
};

export default OverviewSection;
